<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-layout row wrap>
					<v-flex xs6 md6>
						<ValidationProvider
							name="customer_id"
							rules="required"
							v-slot="{ errors }"
						>
							<v-select
								:label="$t('label.customer')"
								v-model="item.customer_id"
								:items="customers"
								item-value="id"
								item-text="id"
								:error-messages="errors"
							></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs6 md6>
						<ValidationProvider
							name="coupon_id"
							rules="required"
							v-slot="{ errors }"
						>
							<v-select
								:label="$t('label.coupon')"
								v-model="item.coupon_id"
								:items="coupons"
								item-value="id"
								item-text="name"
								:error-messages="errors"
							></v-select>
						</ValidationProvider>
					</v-flex>
					<v-flex xs6 md12>
						<ValidationProvider
							name="amount"
							rules="required"
							v-slot="{ errors }"
						>
							<v-text-field
								:label="$t('label.amount')"
								type="number"
								v-model="item.amount"
								data-vv-name="amount"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>

					<v-flex xs12 md12>
						<v-textarea
							:label="$t('Description')"
							v-model="item.description"
						></v-textarea>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
export default {
	props: ["value", "customers", "coupons"],
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>